import { render, staticRenderFns } from "./termlyContent.vue?vue&type=template&id=31b5e40b&scoped=true"
import script from "./termlyContent.vue?vue&type=script&lang=js"
export * from "./termlyContent.vue?vue&type=script&lang=js"
import style0 from "./termlyContent.vue?vue&type=style&index=0&id=31b5e40b&prod&lang=scss&scoped=true"
import style1 from "./termlyContent.vue?vue&type=style&index=1&id=31b5e40b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5e40b",
  null
  
)

export default component.exports